export const INFO = 'INFO';
export const WARNING = 'WARNING';
export const ERROR = 'ERROR';


export const globalMessages = (state = [], action) => {
  if (action.error) {
    const message = {
      level: ERROR,
      text: `${action.error.name}: ${action.error.message}`,
      id: state.length + 1,
    };
    return [...state, message];
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/globalMessageReducer.js